const dateDiff = (day1, day2) => {
    const diff = new Date(day1 - day2);

    const dateDiffMinutes = Math.round(diff.getTime() / 1000 / 60);
    const dateDiffHours = Math.round(diff.getTime() / 1000 / 60 / 60);
    const dateDiffDay = Math.round(diff.getTime() / 1000 / 60 / 60 / 24);

    if (dateDiffHours <= 24 && dateDiffDay < 1) {
        if (dateDiffMinutes < 60 && dateDiffHours < 1) {
            return 'há alguns minutos';
        } else {
            return 'há ' + dateDiffHours + ' horas';
        }
    } else if (dateDiffDay <= 15) {
        return 'há ' + dateDiffDay + ' dias';
    } else {
        return day2.toLocaleDateString('pt-BR').toString();
    }
};

const parseDateIsoToBrStyle = date => {
    // converte datas do padrão AAAA-MM-DD para DD/MM/AAAA.
    const [ano, mes, dia] = date.split('-');
    return ano && mes && dia ? `${dia}/${mes}/${ano}` : null;
};

export const parseToFormat = (dateTimeString, pattern) => {
    const date = new Date(dateTimeString);
    if (isNaN(date.getTime())) {
        throw new RangeError('Invalid time value');
    }

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return pattern
        .replace('DD', day)
        .replace('MM', month)
        .replace('YYYY', year)
        .replace('HH', hours)
        .replace('mm', minutes)
        .replace('ss', seconds);
};

export default {
    dateDiff,
    parseDateIsoToBrStyle,
    parseToFormat
};
